/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */

export const ReportingNew = r => require.ensure([], () => 
                                r(require('../components/list/reportingnew')), 'report-bundle')

export const Reporting = r => require.ensure([], () => 
                                r(require('../components/list/reporting')), 'report-bundle')

export const ReportingsNew = r => require.ensure([], () => 
                                r(require('../components/list/reporting_new')), 'report-bundle')

export const RepeatAffender = r => require.ensure([], () => 
                                r(require('../components/list/repeatAffender.vue')), 'report-bundle')

export const campaignReporting = r => require.ensure([], () => 
                                r(require('../components/list/campaign_reporting')), 'report-bundle')

export const campaignReportingNew = r => require.ensure([], () => 
                                r(require('../components/list/campaign_reporting_new')), 'report-bundle')


export const compareReportingNew = r => require.ensure([], () => 
                                r(require('../components/list/compare_reporting')), 'report-bundle')


export const recipientListing = r => require.ensure([], () => 
                                r(require('../components/list/recipient_listing')), 'report-bundle')

export const campaignDetailedReporting = r => require.ensure([], () => 
                                r(require('../components/list/campaign_detailed_reporting')), 'report-bundle')

export const hcsa = r => require.ensure([], () =>
                                r(require('../components/list/hcsa')), 'report-bundle')
/*
export const recipientProfile = r => require.ensure([], () => 
                                r(require('../components/list/recipient_profile')), 'report-bundle')
 */
 
/*
export const createCampaignMain = r => require.ensure([], () => 
                                r(require('../components/main')), 'campaign-bundle')
 */

export const campaignReportingScenario = r => require.ensure([], () => 
r(require('../components/list/campaign_reporting_scenario')), 'report-bundle')


// WEBPACK FOOTER //
// ./src/app/report/routes/components.js